import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { updateCompanyClientSinceSchema, UpdateCompanyClientSinceSchema } from '../../schemas/updateCompanyClientSince.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { DateInput } from '@/common/components/DateInput/DateInput'
import { useUpdateCompanyClientSince } from '../../hooks/useUpdateCompanyClientSince'
import { useQueryClient } from '@tanstack/react-query'
import { FormTransformers } from '@/common/utils/formTransformers'
import { Pencil } from 'lucide-react'
import { format } from 'date-fns'

export default function ModalUpdateClientSince({clientSince, disabled}: {clientSince?: string, disabled?: boolean}) {
  const { id: companyId } = useParams()

  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
  } = useForm<UpdateCompanyClientSinceSchema>({
    resolver:  zodResolver(updateCompanyClientSinceSchema)
  })

  const {
    mutate: updateCompanyClientSince,
    isPending: isUpdateCompanyClientSincePending,
    isError: isUpdateCompanyClientSinceError,
  } = useUpdateCompanyClientSince({
    companyId,
    onSuccess: () => {
      setMessages(['Data atualizada com sucesso!']);
      queryClient.invalidateQueries({ queryKey: ['company', companyId] });
      setIsOpen(false)
    },
    onError: FormTransformers.errorsTransformer({ setError, setMessages })
  })

  useEffect(() => {
    if(clientSince) {
      reset({
        client_since: format(new Date(clientSince), 'dd/MM/yyyy')
      })
    }
  }, [isOpen])

  const onSubmit: SubmitHandler<UpdateCompanyClientSinceSchema> = (data) => {
    updateCompanyClientSince(data)
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={handleSubmit(onSubmit)}
        Trigger={
          <Button variant="link-white" disabled={disabled}>
            <Pencil className="max-w-4 max-h-4" />
          </Button>
        }
        title="Editar Client Tcard desde"
        footer="Confirmar"
        body={
          <form>
            <DateInput
              fieldName="client_since"
              control={control}
              errors={errors}
              label="Membro Tcard desde"
              markAsRequired
              disabled={isUpdateCompanyClientSincePending}
            />
          </form>
        }
      />
      {messages && <ModalMessageSimple messages={messages} setMessages={setMessages} isError={isUpdateCompanyClientSinceError} />}
    </>
  )
}
